<template>
    <!-- Modal -->
    <div class="modal fade" id="add_new_address_modal" role="dialog" aria-labelledby="myModalLabel" style="z-index:3000 !important">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel2">Add / Update Address Of Customer: {{c_name}}</h4>
                </div>
                <form id="addressForm" method="post" @submit.prevent="updateAddress()">
                <div class="modal-body">
                    <CitiesAndAreas ref="cityAndAreaComp" :isAddingNewCustomer="true" />
                    <div class="form-group">
                        <label >Address</label>
                        <textarea rows="5" class="form-control" placeholder="Address..." v-model="address.address" required="required"></textarea>
                    </div>
                    <div class="checkbox" v-if="userRole==='ROLE_ADMIN'">
                        <label>
                            <input type="checkbox" v-model="address.deleted"/> Disabled
                        </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="submit" v-bind:disabled="disabled" class="btn btn-primary">Save</button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import CitiesAndAreas from "@/components/utils/CitiesAndAreas"
    export default {
        name: "AddNewAddress",
        components: {
            CitiesAndAreas
        },
        data() {
            return {
                disabled: false,
                c_id: "",
                c_name: "",
                address: {
                    "id": 0,
                    "address": "",
                    "deleted": false,
                    "customersByCustomerId": {
                        "id": 0,
                    },
                    "areasByAreaId": {
                        "id": 0,
                        "citiesByCityId": {
                            "id": 0,
                        }
                    }
                },
                userRole:''
            }
        },
        props: [
            "customerName",
            "customerId",
            "from"
        ],
        mounted: function(){
            let modalSelector = $('#add_new_address_modal');
            modalSelector.on('hidden.bs.modal',  (e) => {
               this.resetData();
            });
            modalSelector.on('shown.bs.modal',  (e) => {
                if(this.customerName !== '' && this.customerId !== ''){
                    this.c_name = this.customerName;
                    this.c_id = this.customerId;
                }
            });
        },
        methods: {
            setProps: function (cId, cName) {
              this.c_id = cId;
              this.c_name = cName;
            },
            loadForNewInsertion: function () {
                $("#add_new_address_modal").modal("show");
            },
            loadForUpdate: function (id) {
                let params = new URLSearchParams();
                params.append('address_id', id);
                this.$http.post(this.$store.state.mainAppURL + "customers/get_customer_address", params).then(resp => {
                    this.address = resp.data;
                    console.log(this.address);
                    this.$refs.cityAndAreaComp.selectedCity = this.address.areasByAreaId.citiesByCityId.id;
                    this.$refs.cityAndAreaComp.selectedArea = this.address.areasByAreaId.id;
                    this.$refs.cityAndAreaComp.areas.push(this.address.areasByAreaId);
                    this.$refs.cityAndAreaComp.area= this.address.areasByAreaId;
                    let loggedInUser = this.$store.state.user;
                    if(loggedInUser){
                        this.userRole = loggedInUser.userRolesById[0].role;
                    }
                    $("#add_new_address_modal").modal("show");
                });
            },
            updateAddress: function () {
                this.disabled = true;
                this.address.areasByAreaId.id = this.$refs.cityAndAreaComp.selectedArea;
                this.address.areasByAreaId.citiesByCityId.id = this.$refs.cityAndAreaComp.selectedCity;
                this.address.customersByCustomerId.id = this.c_id;
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                        this.$parent.isHideSpinner="";
                    },
                });
                this.$http.post(this.$store.state.mainAppURL + "customers/update_customer_address", this.address).then(resp => {
                    $("#add_new_address_modal").modal("hide");
                    Swal.close();
                    if(this.from === "vcd"){
                        this.$parent.load(this.c_id, this.c_name, "active");
                    }else{
                        let params= new URLSearchParams();
                        params.append("caller_number", this.$parent.callerNumber);
                        params.append("address_id", resp.data.id);
                        this.$http.post(this.$store.state.mainAppURL + "orders/update_customer_address_in_delivery_order", params).then(resp => {
                            this.$parent.selectedCustomerAddressId= resp.data.customerAddressesByCustomerAddressId.id;
                            this.$parent.fetchCustomerAddresses();
                            this.$parent.popUpSpinner="hide";
                            this.$parent.load(resp.data);
                        })

                    }
                    this.resetData();
                });
            },
            resetData: function () {
                Object.assign(this.$data, this.$options.data.call(this));
                this.$refs.cityAndAreaComp.resetData();
            }
        }
    }
</script>

<style scoped>

</style>
